import {
  postCall,
  getCall,
  putCall,
  patchCall,
  HeadersInterface,
  BodyParamsInterface,
  convertInterfaceToBodyParams,
  QueryParamsInterface,
} from "./api";

const FINANCIAL_STATS_URL = "v1/stats/financial";
const NUMERICAL_STATS_URL = "v1/stats/numerical";
const OTHER_STATS_URL = "v1/stats/other";

export const getFinancialData = async (userId: number) => {
  let url =
    FINANCIAL_STATS_URL + "/collection-historical-value-profit/" + userId;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getItemFinancialData = async (itemId: number) => {
  let url = FINANCIAL_STATS_URL + "/shirt-historical-value-profit/" + itemId;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getCollectionSizeStats = async (userId: number) => {
  let url = NUMERICAL_STATS_URL + "/shirts-in-collection-over-time/" + userId;
  //TODO---------------------------------------------
  url =
    NUMERICAL_STATS_URL + "/shirts-in-collection-over-time?user_id=" + userId;
  //TODO---------------------------------------------
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getShirtsPerTeamStats = async (userId: number) => {
  let url = NUMERICAL_STATS_URL + "/shirts-per-team/" + userId;
  //TODO---------------------------------------------
  url = NUMERICAL_STATS_URL + "/shirts-per-team?user_id=" + userId;
  //TODO---------------------------------------------
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getShirtsPerCompetitionStats = async (userId: number) => {
  let url = NUMERICAL_STATS_URL + "/shirts-per-competition/" + userId;
  //TODO---------------------------------------------
  url = NUMERICAL_STATS_URL + "/shirts-per-competition?user_id=" + userId;
  //TODO---------------------------------------------
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getShirtsPerCountryStats = async (userId: number) => {
  let url = NUMERICAL_STATS_URL + "/shirts-per-country/" + userId;
  //TODO---------------------------------------------
  url = NUMERICAL_STATS_URL + "/shirts-per-country?user_id=" + userId;
  //TODO---------------------------------------------
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getShirtsPerTypeStats = async (userId: number) => {
  let url = NUMERICAL_STATS_URL + "/shirts-per-type/" + userId;
  //TODO---------------------------------------------
  url = NUMERICAL_STATS_URL + "/shirts-per-type?user_id=" + userId;
  //TODO---------------------------------------------
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getShirtsPerSeasonStats = async (userId: number) => {
  let url = NUMERICAL_STATS_URL + "/shirts-per-season/" + userId;
  //TODO---------------------------------------------
  url = NUMERICAL_STATS_URL + "/shirts-per-season?user_id=" + userId;
  //TODO---------------------------------------------
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getShirtsPerDecadeStats = async (userId: number) => {
  let url = NUMERICAL_STATS_URL + "/shirts-per-decade/" + userId;
  //TODO---------------------------------------------
  url = NUMERICAL_STATS_URL + "/shirts-per-decade?user_id=" + userId;
  //TODO---------------------------------------------
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};

export const getShirtsWornInMatchCount = async () => {
  let url = OTHER_STATS_URL + "/shirts-worn-in-match-count";
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, undefined);

  return response;
};
